import className from 'classnames'
import { useMemo, useRef } from 'react'

// This needs to be separated because if we rely on the whole `screenshots` object,
// the images will be updated every time the object changes, thus makes them flicker.
export type PostBoxPhotosLabel = {
  file?: File
  disabled?: boolean
  onChangeImageUpload: (e?: { target?: { files?: FileList | File[] } }) => void
  onDeleteImageUpload: () => void
  accept: string
}

export const PostBoxPhotosLabel = ({
  file,
  disabled,
  onChangeImageUpload,
  onDeleteImageUpload,
  accept,
}: PostBoxPhotosLabel) => {
  const ref = useRef<HTMLInputElement>()

  const url = useMemo(
    () => (file ? `url(${URL.createObjectURL(file)})` : 'none'),
    [file]
  )

  return (
    <label
      className={className('PostBox__body__photos__label', {
        'PostBox__body__photos__label--placeholder': !file,
        'PostBox__body__photos__label--x-disabled': disabled,
      })}
      style={{
        backgroundImage: url,
      }}
    >
      {file && (
        <a
          className="PostBox__body__photos__label__a"
          onClick={(e) => {
            e.preventDefault()
            onDeleteImageUpload()
            ref.current.value = null
          }}
        />
      )}

      <svg viewBox="0 0 1 1" />

      <input
        type="file"
        accept={accept}
        name="file"
        onChange={onChangeImageUpload}
        ref={ref}
      />
    </label>
  )
}
